
import AES from '@/tools/aes.js';
import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage);

// 共用變數
export const dataCeneter = {
  isLogin: function () {
    return this.user.loginToken != null;
  },
  // table一頁顯示的筆數
  config: {
    tablePerPage: 10,
  },
  user: {
    e_Id: null,
    e_Name: null,
    loginToken: null,
    authList: [],
    group: [],
    isMockLogin: false,
  },
  watermarkConfig(){
    var config ={
      text: [vm.$dataCeneter?.user?.e_Id,vm.$dataCeneter?.user?.e_Name],
      fontSize: 45,
      gapX: 500,
      gapY: 500,
      zIndex: 300,
      
    };
   if(vm.$dataCeneter.user.currentsystem != 'business'){
    config = {}
   }
    return config;
  },
  saveData: function () {
    localStorage.setItem("dataCenter", this.AESEncrypt(this.user));
  },
  getData: function () {
    var data = null;
    try{
      data = this.AESDecrypt(localStorage.getItem("dataCenter"));
    }catch(e){
      data =  JSON.parse(localStorage.getItem("dataCenter"));
    }
    if (data == null) {
      return this.user;
    }
    return data;
  },
  getGroupNameBy(id) {
    if (id == null) return null;
    let find = vm.$dataCeneter.tempSalesSelectResponse.list[0].groupList.find(
      (d) => d.group_Id == id
    );
    return find?.group_Name;
  },
  // 加密
  AESEncrypt(res){
    return AES.encrypt(JSON.stringify(res))
  },
  // 解密
  AESDecrypt(res){
    return JSON.parse(AES.decrypt(res));
  }
};
